import { call, put, select, takeLatest, fork } from 'redux-saga/effects';

import { queryMinLoanAmountSuccess } from '../actions';
import MinimumLoanSizeAPI from '../api/MinimumLoanSizeAPI';
import { QUERY_MIN_LOAN_AMOUNT_REQUEST } from '../constants/actionTypes';
import { accessTokenSelector, buildServerSelector } from '../reducers/selectors';

import { manageAPIError } from './helpers/errorHelper';

function* minLoanAmountWatcher() {
  yield takeLatest(QUERY_MIN_LOAN_AMOUNT_REQUEST, minLoanAmountWorker);
}

function* minLoanAmountWorker(action) {
  const { eligibilityId } = action;
  try {
    const accessToken = yield select(accessTokenSelector);
    const builder = yield select(buildServerSelector);
    const { courseMinLoanSize } = builder;
    const payload = yield call(
      MinimumLoanSizeAPI.queryMinimumLoanSizeFor,
      eligibilityId,
      courseMinLoanSize,
      accessToken,
    );
    yield put(queryMinLoanAmountSuccess(payload));
  } catch (error) {
    yield fork(manageAPIError, { ...error, action });
  }
}

export { minLoanAmountWorker };
export default minLoanAmountWatcher;
